import React, { createContext, useContext } from "react";
import { timeAndAttendanceQuery, timeAndAttendanceStore } from "../states";

let operationsAllowed: any = {};
const TimeAndAttendanceServiceContext = createContext(operationsAllowed);

export const TimeAndAttendanceServiceProvider = (props: any) => {

  const getShiftDetailsActiveTabIndex = () => {
    return timeAndAttendanceQuery.getValue().shiftDetails.shiftDetailsPage.activeTabIndex;
  }

  const setShiftDetailsActiveTabIndex = (activeTabIndex: number) => {
    timeAndAttendanceStore.update({shiftDetails: {shiftDetailsPage: {activeTabIndex: activeTabIndex}}});
  }

  operationsAllowed = {
    getShiftDetailsActiveTabIndex,
    setShiftDetailsActiveTabIndex
  };

  return (
    <TimeAndAttendanceServiceContext.Provider value={operationsAllowed}>
      {props.children}
    </TimeAndAttendanceServiceContext.Provider>
  );
}

export const useTimeAndAttendanceService = () => {
  return useContext(TimeAndAttendanceServiceContext);
}
